// Compress/resize an image File before upload using pure browser canvas APIs.
// Returns the original file unchanged if it is not an image, is already small,
// or is a GIF. Never throws: on any error it returns the original file.
const compressImage = async (file, { maxEdge = 2000, quality = 0.8 } = {}) => {
  try {
    if (!file || !file.type || !file.type.startsWith("image/")) {
      return file;
    }
    // Skip GIFs (animation would be lost) and already-small files.
    if (file.type === "image/gif" || file.size < 500 * 1024) {
      return file;
    }

    const bitmap = await createImageBitmap(file);
    const { width, height } = bitmap;
    const longestEdge = Math.max(width, height);

    // Never upscale.
    const scale = longestEdge > maxEdge ? maxEdge / longestEdge : 1;
    const targetWidth = Math.round(width * scale);
    const targetHeight = Math.round(height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight);
    if (bitmap.close) {
      bitmap.close();
    }

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", quality);
    });

    if (!blob) {
      return file;
    }

    const newName = file.name.replace(/\.[^/.]+$/, "") + ".jpg";
    return new File([blob], newName, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error("Error compressing image, using original file:", error);
    return file;
  }
};

export default compressImage;
